<template>
    <div class="">
        <h1>Contact</h1>
    </div>
</template>

<script>
export default {
    name: 'wellful-contact',
    data() {
        return {
            activeItem: 0
        }
    },
    components: {}
}
</script>

<style scoped></style>
